@if(!showEditFeature){
@if(!showEdit){
<div class="main-container">
    <div class="title">
        <span class="title-text">Update Family Code</span>
        <p class="small-title">Enter family code to proceed with the search.</p>
    </div>

    <form [formGroup]="searchForm" (ngSubmit)="searchByFamilyCode()">
        <div class="searchBar">
            <input type="text" maxlength="12" class="searchInput ac-input-control" placeholder="Enter family code"
                formControlName="familyCode" />

            <div class="btn">
                <button type="button" class="ac-secondary-btn" (click)="reset()">
                    Reset
                </button>
                <button type="submit" class="ac-primary-btn" [disabled]="searchForm.invalid">
                    Search
                </button>
            </div>
        </div>
    </form>

    <!-- @if(profileList.length > 0){
    <div class="table-container">
        <table class="table">
            <thead class="table-head">
                <tr>
                    <th>Name</th>
                    <th>Gender</th>
                    <th>Family Code</th>
                    <th>Mobile Number</th>
                    <th>Aadhaar Number</th>
                    <th>Status</th>
                </tr>
            </thead>

            <tbody class="table-body">
                @for(row of profileList; track row){
                <tr (click)="getProfileDetails(row.devoteeFamilyCode)">
                    <td>
                        {{row.devoteeFirstName}} {{row.devoteeMiddleName || ''}}
                        {{row.devoteeLastName}}
                    </td>
                    <td>{{row.gender}}</td>
                    <td>{{row.devoteeFamilyCode}}</td>
                    <td>{{row.mobileNumber}}</td>
                    <td>{{row.idNumber}}</td>
                    <td>{{row.status}}</td>
                </tr>
                }
            </tbody>
        </table>
    </div>
    }  -->
  @if(profileList.length > 0){

  @if(!isMobile){
    <div class="table-container">
      <table class="table">
        <thead class="table-head">
          <tr>
            <th>Name</th>
            <th>Gender</th>
            <th>Family Code</th>
            <th>Mobile Number</th>
            <th>Aadhaar Number</th>
            <th>Status</th>
          </tr>
        </thead>

        <tbody class="table-body">
          @for(row of profileList; track row){
          <tr (click)="getProfileDetails(row.devoteeFamilyCode)">
            <td>{{row.devoteeFirstName}} {{row.devoteeLastName}}</td>
            <td>{{row.gender}}</td>
            <td>{{row.devoteeFamilyCode}}</td>
            <td>{{row.mobileNumber}}</td>
            <td>{{row.idNumber}}</td>
            <td>{{row.status}}</td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  }

  @if(isMobile){
    <div class="mobile-card-list">
      @for(row of profileList; track row){

      <div class="mobile-card"
        (click)="getProfileDetails(row.devoteeFamilyCode)">

        <div class="mc-name">
          {{row.devoteeFirstName}} {{row.devoteeLastName}}
        </div>

        <div class="mc-row">
          <span class="mc-label">Gender</span>
          <span class="mc-value">{{row.gender}}</span>
        </div>

        <div class="mc-row">
          <span class="mc-label">Family Code</span>
          <span class="mc-value">{{row.devoteeFamilyCode}}</span>
        </div>

        <div class="mc-row">
          <span class="mc-label">Mobile</span>
          <span class="mc-value">{{row.mobileNumber}}</span>
        </div>

        <div class="mc-row">
          <span class="mc-label">Aadhaar</span>
          <span class="mc-value">{{row.idNumber}}</span>
        </div>

        <div class="mc-row">
          <span class="mc-label">Status</span>
          <span class="mc-value">{{row.status}}</span>
        </div>

      </div>

      }
    </div>
  }

}
    @else {
    <div class="list-div">
        <div class="img-div">
            <img style="width: 150px;" src="icons/search_placeholder_dark.png" alt="">
            <span class="drop-title" style="text-align: end;">No Data Found</span>
        </div>
    </div>
    }
</div>
}
@else {
<div class="main-container">
    <div class="title">
        <span class="back-btn" style="color: var(--brand-primary); cursor:pointer" (click)="back()">
             <img src="icons/back-arrow-icon.svg" style="height: 15px; width: 15px;">
            Go back
        </span>
        <!-- <span class="title-text">
            Update Family Code - ({{profileDetails[0]?.devoteeFamilyCode}})
        </span> -->

        <div class="title-header">
            <span class="title-text">
                Update Family Code - ({{profileDetails[0]?.devoteeFamilyCode}})
            </span>
        <button
  class="update-btn"
  (click)="updateAllFamilyMembers()"
>
  Update all Family Members
</button>


        </div>
    </div>

    <div class="card-details">
        @for(item of profileDetails; track item){
        <div class="family-details">
            <div class="details">
                <div class="name-row">

                    @if(item.isPrimaryDevotee){
                    <div class="primary-devotee">
                        <span class="common-text">
                            {{ item.devoteeFirstName }} {{ item.devoteeLastName }}


                            @if(item.workerType){
                            <span class="worker-type">({{ item.workerType }})</span>
                            }
                        </span>


                        <img src="icons/verified-badge-line.png" style="width: 20px; height: 20px;" alt="badge-img">


                    @if(!isMobile){
                    <div class="pending-design">
                        <span class="pending">Primary Devotee</span>
                    </div>
                    }

                    </div>
                    }
                    @else {
                    <span class="common-text">
                        {{ item.devoteeFirstName }} {{ item.devoteeLastName }}
                        @if(item.workerType){
                        <span class="worker-type">({{ item.workerType }})</span>
                        }
                    </span>
                    }

                </div>
            </div>


            <div class="details">
                <span class="common-header">Mobile</span>
                <span class="common-text">{{ item.mobileNumber }}</span>
            </div>

            <div class="details">
                <span class="common-header">Aadhaar</span>
                <span class="common-text">{{ item.idNumber }}</span>
            </div>
            @if((profileDetails.length === 1 && item.isPrimaryDevotee) || (profileDetails.length > 1 && !item.isPrimaryDevotee) 
            || (profileDetails.length > 1 && item.status === 'INACTIVE' && item.isPrimaryDevotee) ){
            <div class="edit">
                <button class="ac-secondary-btn" (click)="updateFamilyCode(item)">
                    Update Family Code
                </button>
            </div>
        }
        </div>
        }
    </div>
</div>
}
}

<app-edit-devotee-fc [isOpen]="showEditFeature" [updateMember]="updateMember"  [isAccntExist]="accountExist" [devoteeDetails]="selectedDevotee" [profileList]="this.profileList" [updatedFc]="newFc" [newMemberCode]="newMemberCode" (close)="onCloseEdit($event)"></app-edit-devotee-fc>